import caseManagementRoutes from "./Pages/CaseManagement/case-management-routes.js";
import coreRoutes from "./Pages/Core/core-routes.js";
import nursingRoutes from "./Pages/Nursing/nursing-routes.js";
import systemRoutes from "./Pages/System/system-routes.js";

/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const routes = [
    ...coreRoutes,
    ...caseManagementRoutes,
    ...nursingRoutes,
    ...systemRoutes
];

export default routes;